import React from "react";

const MilestoneRecordsGrid = ({
  records = [],
  readOnly = false,
  onChange,
  variant = "default",
}) => {
  const updateRow = (index, field, value) => {
    const next = records.map((row, i) =>
      i === index ? { ...row, [field]: value } : row,
    );
    onChange(next);
  };

  const addRow = () => {
    onChange([
      ...records,
      {
        RecordName: "",
        RecordType: "Triggering",
        SortOrder: records.length,
      },
    ]);
  };

  const removeRow = (index) => {
    onChange(records.filter((_, i) => i !== index));
  };

  return (
    <div
      className={[
        "milestone-records-grid",
        variant === "sidebar" ? "milestone-records-grid--sidebar" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="milestone-records-grid__header">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="milestone-panel-title mb-0">Expected documents</h6>
          {!readOnly && (
            <button type="button" className="btn btn-outline-primary btn-sm" onClick={addRow}>
              <i className="fa fa-plus me-1" aria-hidden="true" />
              Add document
            </button>
          )}
        </div>
        <p className="small text-muted mb-2">
          Each row becomes a placeholder when this milestone is applied to a template.
        </p>
      </div>
      <div
        className={
          variant === "sidebar"
            ? "milestone-records-grid__scroll"
            : "milestone-records-grid__body"
        }
      >
        {records.length === 0 ? (
          <div className="text-muted small border rounded p-2 bg-light">
            No extra documents defined — one placeholder will use the milestone name.
          </div>
        ) : (
          <div className="table-responsive milestone-records-grid__table-wrap">
            <table className="table table-sm align-middle mb-0 milestone-records-grid__table">
              <thead>
                <tr>
                  <th className="milestone-records-grid__name-col">
                    Document / placeholder name
                  </th>
                  <th className="milestone-records-grid__actions-col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {records.map((row, index) => (
                  <tr key={`record-${index}`}>
                    <td className="milestone-records-grid__name-col">
                      <input
                        className="form-control form-control-sm milestone-records-grid__input"
                        disabled={readOnly}
                        value={row.RecordName || ""}
                        placeholder="e.g. SIV Visit Report"
                        onChange={(e) => updateRow(index, "RecordName", e.target.value)}
                      />
                    </td>
                    <td className="milestone-records-grid__actions-col">
                      {!readOnly && (
                        <button
                          type="button"
                          className="milestone-records-grid__remove-btn"
                          onClick={() => removeRow(index)}
                        >
                          Remove
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default MilestoneRecordsGrid;
